import { Component, OnInit, Inject } from '@angular/core';
import { AccountService } from '../../../../../services/account.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-revert-addon-dialog',
  templateUrl: './revert-addon-dialog.component.html',
  styleUrls: ['./revert-addon-dialog.component.css']
})
export class RevertAddonDialogComponent implements OnInit {
  licenseDetails: any;
  api_error: any;
  api_success: string;
  revert;
  addonorlicense;
  acclicid;
  type: string;
  disableConfirmbtn = false;
  constructor(
    private dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: number,
    private accountService: AccountService) { }
  ngOnInit() {
    this.type = this.data['type'];
    this.addonorlicense = this.data['addonorlicense'];
    this.revert = this.addonorlicense.downgradTo;
  }
  public closeDialog() {
    this.dialogRef.close();
  }
  onConfirm() {
    this.api_error = '';
    this.disableConfirmbtn = true;
    this.acclicid = this.addonorlicense.accountLicId;
    this.accountService.revertAddon(this.acclicid, this.data['accountId'])
      .subscribe(
        data => {
          if (this.revert === 0) {
            this.disableConfirmbtn = true;
            this.api_success = 'Revert Successfully';
          } else {
            if (this.type === 'addons') {
              this.disableConfirmbtn = true;
              this.api_success = 'Revert Successfully';
            } else {
              this.disableConfirmbtn = true;
              this.api_success = 'Revert Successfully';
            }
          }
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
        (error) => {
          this.disableConfirmbtn = false;
          this.api_error = error.error;
        }
      );
  }
}
